export default __webpack_public_path__ + "b803459b35f6e62a597d8e8951124ace.png";